import * as React from 'react'
// CComponents
import {Button} from '@frontrow/console/src/components/button'

import * as style from '../school-admin-form/school-admin-form.module.scss'

type Props = {
  onCancel: () => void
  onSubmit: () => void
}

function SchoolAdminsDistrictForm(props: Props): React.ReactElement {
  const {onCancel, onSubmit} = props

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    onSubmit()
  }

  return (
    <form onSubmit={handleSubmit} action="">
      <div className={style.schoolAdminFormButtonContainer}>
        <Button style="secondary" addClass={style.schoolAdminFormCancel} onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit">Delete School Admin</Button>
      </div>
    </form>
  )
}

export default SchoolAdminsDistrictForm
